export default "/_next/static/chunks/fonts/DAZN Oscine ExtraBold-92bafe10e60a149779aec650c5fe0712.ttf";